// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "./helper/route";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/general.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ScrollToTop } from "./components/ScrollToTop";
import { GlobalStateProvider } from "./context/GlobalStateContext";

function App() {
  return (
    <div className="App">
      <Router>
        <GlobalStateProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={true}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <ScrollToTop>
            <Routes>
              {routes?.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>
          </ScrollToTop>
        </GlobalStateProvider>
      </Router>
    </div>
  );
}

export default App;
